import React, { useState } from 'react';
import { LabeledInput, CheckBox, SelectInput } from '../../../Components';
import './Index.css';
const Index = ({ gst }) => {
    const [width, setWidth] = useState(10);
    const [heigth, setHeight] = useState(10);
    const [additionalPrintCost, setadditionalPrintCost] = useState(30);
    const [addon, setAddon] = useState(15);
    const [printCost, setprintCost] = useState(65);
    const [maxPrintHeight, setMaxPrintHeight] = useState(16);
    const [maxPrintWidth, setMaxPrintWidth] = useState(11.5);
    const [maxNeckLabelHeight, setMaxNeckLabelHeight] = useState(2.5);
    const [screenPrice, setScreenPrice] = useState(150);
    const [labelScreenPrice, setLabelScreenPrice] = useState(150);
    const [maxNeckLabelWidth, setMaxNeckLabelWidth] = useState(3);
    const [maxSleeveLabelHeight, setMaxSleeveLabelHeight] = useState(2.5);
    const [maxSleeveLabelWidth, setMaxSleeveLabelWidth] = useState(3);
    const [neckLabelPrice, setNeckLabelPrice] = useState(7);
    const [colorFirst, setColorFirst] = useState(1);
    const [colorSecond, setColorSecond] = useState(1);
    const [hasaNeckLabel, setNeckLabel] = useState(false);
    const [additionaPrint, setadditionaPrint] = useState(false);
    const [hasaBackLabel, setBacklabel] = useState(false);
    const [isSleevePrint, setSleevePrint] = useState(false);
    const [backLabelCost, setBackLabelCost] = useState(7);
    const [sleevePrintCost, setSleevePrintCost] = useState(20);
    const [sleevePrintAddon, setSleevePrintAddon] = useState(15);
    const [colorThird, setColorThird] = useState(1);

    const neckLabelCheckhandler = (name, currentState) => {
        setNeckLabel(!currentState);
    };
    const backLabelCheckHandler = (name, currentState) => {
        setBacklabel(!currentState);
    };
    const addtionalPrintChangeHandler = (name, currentState) => {
        setadditionaPrint(!currentState);
    };
    const sleevePrintChangeHandler = (name, currentState) => {
        setSleevePrint(!currentState);
    };
    let price = 150 + 50 + printCost;
    price += (colorFirst - 1) * addon;

    if (hasaNeckLabel) {
        price += neckLabelPrice;
    }
    if (additionaPrint) {
        price += additionalPrintCost;
        price += (colorSecond - 1) * addon;
    }

    if (hasaBackLabel) {
        price += backLabelCost;
    }
    if (isSleevePrint) {
        price += sleevePrintCost;
        price += (colorThird - 1) * sleevePrintAddon;
    }
    price += price * (gst / 100);
    return (
        <div className="pricing_body_screenprint">
            <div className="home_head">
                <h2 className="home_heading"> Screen Print</h2>
            </div>
            <div>
                <div>
                    <p>
                        <span>Delivery Cost:</span> 50₹
                    </p>
                    <p>
                        <span>Printing Type:</span> Screen Print
                    </p>
                    <LabeledInput
                        style={{ width: '100%', maxWidth: '280px' }}
                        type="number"
                        name="Width"
                        value={width}
                        changeHandler={(e) => {
                            setWidth(e.target.value);
                        }}
                        label={`Design Width (in inches) - Max. ${maxPrintWidth} inches*`}
                    />
                    <LabeledInput
                        style={{ width: '100%', maxWidth: '280px', marginBottom: '0' }}
                        type="number"
                        name="Height"
                        value={heigth}
                        changeHandler={(e) => {
                            setHeight(e.target.value);
                        }}
                        label={`Design Height (in inches) - Max. ${maxPrintHeight} inches*`}
                    />
                    <p style={{ marginBottom: '2rem' }} className="input_info">
                        *Contact for bigger design size, printing possible 13 x 17.5 inches
                    </p>
                    <CheckBox
                        style={{ marginBottom: '0' }}
                        name="printed"
                        value="printed"
                        labeling="Front/Back Print"
                        checked={true}
                    />
                    <p style={{ marginBottom: '2rem' }} className="input_info">
                        Print has Fix Price of {printCost}₹ with add-on price per color of {addon}₹ (Maximum Dimension :{' '}
                        {maxPrintHeight}in X{maxPrintWidth}in)
                    </p>
                    <div style={{ width: 'max-content' }}>
                        <SelectInput
                            style={{ width: 'max-content' }}
                            label="Number of Colors in Front/Back Design"
                            outlined={true}
                            value={colorFirst}
                            changeHandler={(e) => {
                                setColorFirst(e.target.value);
                            }}
                            options={[
                                { name: '1', value: 1 },
                                { name: '2', value: 2 },
                                { name: '3', value: 3 },
                                { name: '4', value: 4 },
                                { name: '5', value: 5 },
                                { name: '6', value: 6 },
                            ]}
                        />
                    </div>
                    <CheckBox
                        style={{ marginBottom: '0' }}
                        name="isAdditionalPrinted"
                        value="isAdditionalPrinted"
                        labeling="Additional Front/Back Print"
                        checked={false}
                        handleChange={addtionalPrintChangeHandler}
                    />
                    <p style={{ marginBottom: '2rem' }} className="input_info">
                        Additional Print has Fix Price of {additionalPrintCost}₹ with add-on price per color of {addon}₹
                        (Maximum Dimension : {maxPrintHeight}in X{maxPrintWidth}in)
                    </p>
                    <div style={{ width: 'max-content' }}>
                        <SelectInput
                            style={{ width: 'max-content' }}
                            label="Number of Colors in Additional Front/Back Design"
                            outlined={true}
                            value={colorSecond}
                            changeHandler={(e) => {
                                setColorSecond(e.target.value);
                            }}
                            options={[
                                { name: '1', value: 1 },
                                { name: '2', value: 2 },
                                { name: '3', value: 3 },
                                { name: '4', value: 4 },
                                { name: '5', value: 5 },
                                { name: '6', value: 6 },
                            ]}
                        />
                    </div>
                    <CheckBox
                        style={{ marginBottom: '0' }}
                        name="isSleevePrinted"
                        value="isSleevePrinted"
                        labeling="Sleeve Printed"
                        checked={false}
                        handleChange={sleevePrintChangeHandler}
                    />
                    <p style={{ marginBottom: '2rem' }} className="input_info">
                        Sleeve Print has Fix Price of {sleevePrintAddon}₹ with add-on price per color of{' '}
                        {sleevePrintAddon}₹ (Maximum Dimension : {maxSleeveLabelHeight}in X{maxSleeveLabelWidth}in)
                    </p>
                    <div style={{ width: 'max-content' }}>
                        <SelectInput
                            style={{ width: 'max-content' }}
                            label="Number of Colors in Sleeve Design"
                            outlined={true}
                            value={colorThird}
                            changeHandler={(e) => {
                                setColorThird(e.target.value);
                            }}
                            options={[
                                { name: '1', value: 1 },
                                { name: '2', value: 2 },
                                { name: '3', value: 3 },
                                { name: '4', value: 4 },
                                { name: '5', value: 5 },
                                { name: '6', value: 6 },
                            ]}
                        />
                    </div>
                    <CheckBox
                        style={{ marginBottom: '0' }}
                        handleChange={neckLabelCheckhandler}
                        name="isNeckLabel5"
                        value="isNeckLabel5"
                        labeling="has a Neck Label?"
                        checked={false}
                    />
                    <p style={{ marginBottom: '2rem' }} className="input_info">
                        Neck Label has fix price {neckLabelPrice}₹ (Maximum Dimension : {maxNeckLabelHeight}in X
                        {maxNeckLabelWidth}in)
                    </p>
                    <CheckBox
                        style={{ marginBottom: '0' }}
                        handleChange={backLabelCheckHandler}
                        name="isBacklabel"
                        value="isBacklabel"
                        labeling="has a Back Label?"
                        checked={false}
                    />
                    <p style={{ marginBottom: '2rem' }} className="input_info">
                        Neck Label has fix price {backLabelCost}₹
                    </p>
                    <p>
                        <span>Total Price (inclusive of shipping and {gst}% GST):</span> {price}₹
                    </p>
                </div>
                <div>
                    <p>
                        <span>Set Pricing Values</span>
                    </p>
                    <LabeledInput
                        style={{ width: '100%', maxWidth: '280px' }}
                        type="number"
                        label="One Time Screen Price ₹"
                        name="Screen Price"
                        value={screenPrice}
                        changeHandler={(e) => {
                            setScreenPrice(e.target.value);
                        }}
                    />
                    <LabeledInput
                        style={{ width: '100%', maxWidth: '280px' }}
                        type="number"
                        label="One Time Label Screen Price ₹"
                        name="Label Screen Price"
                        value={labelScreenPrice}
                        changeHandler={(e) => {
                            setLabelScreenPrice(e.target.value);
                        }}
                    />
                    <LabeledInput
                        style={{ width: '100%', maxWidth: '280px' }}
                        type="number"
                        label="Front/Back Print Cost ₹"
                        name="print"
                        value={printCost}
                        changeHandler={(e) => {
                            setprintCost(e.target.value);
                        }}
                    />

                    <LabeledInput
                        style={{ width: '100%', maxWidth: '280px' }}
                        type="number"
                        label="Additional Front/Back Print Price ₹"
                        name="additonal print"
                        value={additionalPrintCost}
                        changeHandler={(e) => {
                            setadditionalPrintCost(e.target.value);
                        }}
                    />
                    <LabeledInput
                        style={{ width: '100%', maxWidth: '280px' }}
                        type="number"
                        label="Front/Back Multiple Color add-on cost ₹"
                        name="color 1 addon"
                        value={addon}
                        changeHandler={(e) => {
                            setAddon(e.target.value);
                        }}
                    />
                    <LabeledInput
                        style={{ width: '100%', maxWidth: '280px' }}
                        type="number"
                        label="Sleeve Print cost ₹"
                        name="sleeve print csot"
                        value={sleevePrintCost}
                        changeHandler={(e) => {
                            setSleevePrintCost(e.target.value);
                        }}
                    />
                    <LabeledInput
                        style={{ width: '100%', maxWidth: '280px' }}
                        type="number"
                        label="Sleeve Multiple Color add-on cost ₹"
                        name="color 1 addon"
                        value={sleevePrintAddon}
                        changeHandler={(e) => {
                            setSleevePrintAddon(e.target.value);
                        }}
                    />
                    <LabeledInput
                        style={{ width: '100%', maxWidth: '280px' }}
                        type="number"
                        label="Neck Label Price ₹"
                        name="necklabel"
                        value={neckLabelPrice}
                        changeHandler={(e) => {
                            setNeckLabelPrice(e.target.value);
                        }}
                    />
                    <LabeledInput
                        style={{ width: '100%', maxWidth: '280px' }}
                        type="number"
                        label="Back Label Price ₹"
                        name="back"
                        value={backLabelCost}
                        changeHandler={(e) => {
                            setBackLabelCost(e.target.value);
                        }}
                    />
                    <div className="pricing_body_dimensions">
                        <p>Print Dimension Maximum Value:</p>
                        <div>
                            <LabeledInput
                                style={{ width: '100%', maxWidth: '280px' }}
                                type="number"
                                label="Width(inches):"
                                name="widthprint"
                                value={maxPrintHeight}
                                changeHandler={(e) => {
                                    setMaxPrintHeight(e.target.value);
                                }}
                            />
                            <LabeledInput
                                style={{ width: '100%', maxWidth: '280px' }}
                                type="number"
                                label="Height(inches):"
                                name="Heightprint"
                                value={maxPrintWidth}
                                changeHandler={(e) => {
                                    setMaxPrintWidth(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                    <div className="pricing_body_dimensions">
                        <p>Neck Label Dimension Maximum Value:</p>
                        <div>
                            <LabeledInput
                                style={{ width: '100%', maxWidth: '280px' }}
                                type="number"
                                label="Width(inches):"
                                name="widthlabel"
                                value={maxNeckLabelHeight}
                                changeHandler={(e) => {
                                    setMaxNeckLabelHeight(e.target.value);
                                }}
                            />
                            <LabeledInput
                                style={{ width: '100%', maxWidth: '280px' }}
                                type="number"
                                label="Height(inches):"
                                name="Heightlabel"
                                value={maxNeckLabelWidth}
                                changeHandler={(e) => {
                                    setMaxNeckLabelWidth(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                    <div className="pricing_body_dimensions">
                        <p>Sleeve Print Dimension Maximum Value:</p>
                        <div>
                            <LabeledInput
                                style={{ width: '100%', maxWidth: '280px' }}
                                type="number"
                                label="Width(inches):"
                                name="widthlabel"
                                value={maxSleeveLabelHeight}
                                changeHandler={(e) => {
                                    setMaxSleeveLabelHeight(e.target.value);
                                }}
                            />
                            <LabeledInput
                                style={{ width: '100%', maxWidth: '280px' }}
                                type="number"
                                label="Height(inches):"
                                name="Heightlabel"
                                value={maxSleeveLabelWidth}
                                changeHandler={(e) => {
                                    setMaxSleeveLabelWidth(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                    <button className="btn-orange">Update Values</button>
                </div>
            </div>
        </div>
    );
};

export default Index;
